<template>
  <div :class="item.disabled ? 'disabled' : ''">
    <router-link
      v-if="item.to && isInternalRoute"
      :to="item.to"
      class="dropdown-item"
      :data-test="testId"
    >
      <slot />
    </router-link>
    <a
      v-else-if="item.to && !isInternalRoute"
      :href="item.to.name"
      target="_blank"
      class="dropdown-item"
      :data-test="testId"
    >
      <slot />
    </a>
    <BtnLink v-else @click="itemAction(item)" class="dropdown-item" :testId="testId">
      <slot />
    </BtnLink>
  </div>
</template>

<script>
import BtnLink from "@/components/display/BtnLink";
import { computed } from "vue";
import Router from "@/router";

export default {
  name: "DropDownItemMap",
  components: {
    BtnLink,
  },
  props: {
    testId: String,
    item: {
      type: Object,
      required: true,
    },
  },
  emits: ["clicked"],
  setup: (props, { emit }) => {
    const isInternalRoute = computed(() =>
      props.item?.to ? Router.hasRoute(props.item.to.name) : false
    );

    const itemAction = () => {
      if (props.item.action) {
        props.item.action();
        emit("clicked");
      }
    };

    return {
      isInternalRoute,
      itemAction,
    };
  },
};
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  > * {
    pointer-events: none;
  }
}

.dropdown-item {
  @apply tw-inline-flex tw-bg-transparent tw-text-current;
  padding: 0;
  text-decoration: none;
}
</style>
